var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.file.status !== _vm.STATUS_DELETED
    ? _c(
        "div",
        {
          staticClass:
            "uploader-input-element bg-white border br-4 font-size-110 position-relative",
          class: {
            ["local-id-" + _vm.file.localId]: true,
            [_vm.file.status]: true,
            "mb-2": !_vm.isLast,
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "px-3 py-2 d-flex align-items-center justify-content-between flex-row",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-inline-flex py-1 pr-4 justify-content-between flex-wrap flex-sm-nowrap flex-basis-100 flex-shrink-1 ml-n2_ mb-n2 flex-grow-1-unimportant",
                  staticStyle: { "min-width": "0" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center ml-2_ mb-2 overflow-hidden",
                    },
                    [
                      _vm.showStatusWaiting ||
                      _vm.file.status === _vm.STATUS_DELETING ||
                      _vm.file.status === _vm.STATUS_LOADING ||
                      _vm.file.status === _vm.STATUS_SETTING_PASSWORD
                        ? _c(
                            "div",
                            {
                              staticClass: "d-flex",
                              class:
                                _vm.file.status === _vm.STATUS_SETTING_PASSWORD
                                  ? "mr-2_"
                                  : "mr-3",
                            },
                            [
                              _c("span", {
                                staticClass: "spin-circle-basic opacity-65",
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showStatusWaiting
                        ? [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "overflow-hidden text-overflow-ellipsis",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("trans")("Initializing")) +
                                    "..."
                                ),
                              ]
                            ),
                          ]
                        : [
                            _vm.file.status === _vm.STATUS_LOADING
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-info mr-2_" },
                                  [
                                    _vm.file.type === _vm.TYPE_FILE_UPLOAD
                                      ? [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Uploading"))
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(_vm._f("trans")("Adding"))
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm.file.status === _vm.STATUS_PASSWORD_MISSING
                              ? _c("i", { staticClass: "far fa-lock mr-2_" })
                              : _vm.file.status === _vm.STATUS_DELETING
                              ? _c(
                                  "span",
                                  { staticClass: "mr-2_ badge badge-danger" },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm._f("trans")("Removing")) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _vm.file.status === _vm.STATUS_FAILED
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "mr-2_ badge badge-danger",
                                    class:
                                      _vm.file.lastEventData?.error ===
                                        _vm.STATUS_TOO_MANY_INPUT &&
                                      "premium-bg",
                                  },
                                  [
                                    _vm.file.size === 0
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")(
                                                "Your file is empty"
                                              )
                                            )
                                          ),
                                        ]
                                      : _vm.file.lastEventData?.error ===
                                        _vm.STATUS_TOO_MANY_INPUT
                                      ? [
                                          _vm.isSingleInput
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("trans")(
                                                      "Single file feature"
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("trans")(
                                                      "Premium required"
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      : _vm.file.type === _vm.TYPE_FILE_UPLOAD
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Upload failed")
                                            )
                                          ),
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("trans")("Adding failed")
                                            )
                                          ),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "overflow-hidden text-overflow-ellipsis white-space-nowrap",
                                attrs: { title: _vm.file.name },
                              },
                              [_vm._v(_vm._s(_vm.file.name))]
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.statusBadges.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "ml-2_ mb-2 mt-n1 flex-sm-shrink-0 test",
                        },
                        [
                          _vm._l(_vm.statusBadges, function (badge, idx) {
                            return [
                              _c("FileBadge", {
                                key: idx + badge.classes,
                                attrs: {
                                  "add-margin-class":
                                    idx < _vm.statusBadges.length - 1,
                                  icon: badge.icon,
                                  "is-icon-before-text":
                                    badge.iconBefore === true,
                                  text: badge.text,
                                  title: badge.title,
                                  classes: badge.classes + " mt-1",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    badge.icon === _vm.TYPE_GDRIVE ||
                                    badge.icon === _vm.TYPE_DROPBOX
                                      ? {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              badge.icon === _vm.TYPE_GDRIVE
                                                ? _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "15px",
                                                        viewBox: "0 0 87.3 78",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z",
                                                          fill: "#0066da",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z",
                                                          fill: "#00ac47",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z",
                                                          fill: "#ea4335",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z",
                                                          fill: "#00832d",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z",
                                                          fill: "#2684fc",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z",
                                                          fill: "#ffba00",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              badge.icon === _vm.TYPE_DROPBOX
                                                ? _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        viewBox: "0 0 43 40",
                                                        version: "1.1",
                                                        width: "15px",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
                                                          fill: "#007EE5",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                          proxy: true,
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.file.status === _vm.STATUS_DONE || _vm.showRemoveFileButton
                ? _c(
                    "div",
                    {
                      staticClass: "d-inline-flex align-self-baseline",
                      staticStyle: { "padding-top": "0.125rem" },
                    },
                    [
                      _vm.file.status === _vm.STATUS_DONE
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-light border icon-25 p-0 mr-3",
                              class: {
                                "visibility-hidden":
                                  _vm.fileMetaBadges.length === 0,
                              },
                              attrs: {
                                title: _vm._f("trans")(
                                  "Show more information about this file"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.toggleInfo.apply(null, arguments)
                                },
                              },
                            },
                            [_c("i", { staticClass: "far fa-info-circle" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRemoveFileButton
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-danger icon-25 p-0",
                              class: {
                                disabled:
                                  _vm.file.status ===
                                  _vm.STATUS_SETTING_PASSWORD,
                              },
                              attrs: {
                                title: _vm._f("trans")("Remove file from task"),
                                disabled:
                                  _vm.file.status ===
                                  _vm.STATUS_SETTING_PASSWORD,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.removeFile.apply(null, arguments)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.showInfo && _vm.fileMetaBadges.length > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "w-100 d-flex flex-wrap py-3 px-3 border-top bg-cheap-white br-4 rounded-top-0",
                },
                [
                  _c(
                    "div",
                    { staticClass: "mb-n1" },
                    _vm._l(_vm.fileMetaBadges, function (badge, idx) {
                      return _c("FileBadge", {
                        key: idx + badge.classes,
                        attrs: {
                          icon: badge.icon,
                          "is-icon-before-text": badge.iconBefore === true,
                          text: badge.text,
                          title: badge.title,
                          classes: badge.classes + " mb-1",
                        },
                      })
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.file.status === _vm.STATUS_PASSWORD_MISSING ||
          _vm.file.status === _vm.STATUS_SETTING_PASSWORD
            ? _c(
                "div",
                {
                  staticClass:
                    "py-3 w-100 px-3 border-top bg-cheap-white br-4 rounded-top-0",
                },
                [
                  _c("div", [
                    _c(
                      "p",
                      { staticClass: "font-size-110 font-weight-bold mb-2" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")("Your file is password protected")
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "font-size-110 mb-3" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("trans")(
                              "Please enter your password so we can continue processing your file."
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-items-center ml-n3 flex-wrap",
                    },
                    [
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(
                          _vm._s(_vm._f("trans")("Enter file password")) + ":"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "ml-3 mr-n2_ mb-n2 d-flex flex-wrap" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.passwordInput,
                                expression: "passwordInput",
                              },
                            ],
                            ref: "passwordInputField",
                            staticClass: "border py-1 px-2 br-4 mr-2_ mb-2",
                            attrs: {
                              type: "password",
                              name: `input-decrypt-password-${_vm.file.localId}`,
                              placeholder: _vm._f("trans")("Password"),
                              disabled:
                                _vm.file.status === _vm.STATUS_SETTING_PASSWORD,
                            },
                            domProps: { value: _vm.passwordInput },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.setFilePassword.apply(
                                  null,
                                  arguments
                                )
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.passwordInput = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("ButtonWithLoadingState", {
                            staticClass: "btn btn-info py-1 mr-2_ mb-2",
                            attrs: {
                              "data-file-row-password-submit": "",
                              text: _vm._f("trans")("Submit"),
                              icon: "far fa-unlock-alt mr-1_",
                              "is-state-loading":
                                _vm.file.status === _vm.STATUS_SETTING_PASSWORD,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.setFilePassword.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              key: _vm.progressBarKey,
              staticClass:
                "p-0 w-100 left-0 bottom-0 position-absolute overflow-hidden br-4 rounded-top-0 bg-cheap-white border-top",
              staticStyle: { height: "4px" },
            },
            [
              _c("div", {
                staticClass: "progress-bar h-100",
                class: _vm.progressBarClass,
                style: { width: _vm.progressBarWidth },
              }),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }